module.exports = __webpack_public_path__ + "img/up-arrow.1a53e2c3.svg";